import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, Plus } from "lucide-react";
import { StatusBadge } from "../../components/shared/StatusBadge";
import { api } from "../../lib/api";

export default function ReservationsPage() {
  const [statusFilter, setStatusFilter] = useState("");
  const [search, setSearch] = useState("");
  const [reservations, setReservations] = useState([]);
  useEffect(() => {
    const params = {};
    if (statusFilter) params.status = statusFilter;
    if (search) params.q = search;
    api.get("/admin/reservations", { params }).then((r) => setReservations(r.data)).catch(() => setReservations([]));
  }, [statusFilter, search]);
  return (
    <div data-testid="admin-reservations-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="overline-ae">B02 — Commandes &amp; Réservations</p>
          <h1 className="mt-1 font-heading text-2xl sm:text-3xl text-deepgreen">Commandes &amp; Réservations</h1>
        </div>
        <button type="button" className="btn-primary-ae !px-5 !py-2.5 !text-xs" data-testid="admin-new-reservation">
          <Plus className="h-4 w-4" /> Création manuelle
        </button>
      </div>

      <div className="card-ae mt-6">
        <div className="flex flex-wrap items-center gap-3 border-b border-border px-5 py-4">
          <div className="relative flex-1 min-w-52">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <input className="input-ae !pl-9" placeholder="Rechercher (référence, client…)" data-testid="admin-reservations-search" value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
          <select className="input-ae w-auto" data-testid="admin-reservations-status-filter" aria-label="Filtrer par statut" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="">Tous les statuts</option>
            <option value="nouvelle_demande">Nouvelle demande</option>
            <option value="en_attente_finalisation">En attente de finalisation</option>
            <option value="confirmee">Confirmée</option>
            <option value="modification_demandee">Modification demandée</option>
            <option value="passee">Passée</option>
            <option value="annulee">Annulée</option>
            <option value="refusee">Refusée</option>
          </select>
          <select className="input-ae w-auto" data-testid="admin-reservations-type-filter" aria-label="Filtrer par type">
            <option>Tous types</option><option>Location</option><option>Coordination</option><option>Location + Coordination</option>
          </select>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="admin-reservations-table">
            <thead>
              <tr className="border-b border-border text-left text-xs uppercase tracking-wider text-muted-foreground">
                <th className="px-5 py-3">Référence</th>
                <th className="px-5 py-3">Client</th>
                <th className="px-5 py-3">Événement</th>
                <th className="px-5 py-3">Date</th>
                <th className="px-5 py-3 text-right">Total TTC</th>
                <th className="px-5 py-3">Statut</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {reservations.map((r) => (
                <tr key={r.id} className="transition-colors hover:bg-cream/60">
                  <td className="px-5 py-3.5">
                    <Link to={`/admin/reservations/${r.id}`} className="font-semibold text-deepgreen hover:text-sage" data-testid={`admin-reservation-link-${r.ref}`}>{r.ref}</Link>
                  </td>
                  <td className="px-5 py-3.5">{r.customer ? `${r.customer.first_name} ${r.customer.last_name}` : "—"}</td>
                  <td className="px-5 py-3.5">{r.event?.type || "—"}</td>
                  <td className="px-5 py-3.5">{r.event?.start_date || "—"}</td>
                  <td className="px-5 py-3.5 text-right font-semibold">{(r.totals?.total_ttc ?? 0).toFixed(2)} €</td>
                  <td className="px-5 py-3.5"><StatusBadge status={r.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="border-t border-border px-5 py-3 text-xs text-muted-foreground">Archivage plutôt que suppression — l'historique est toujours conservé.</p>
      </div>
    </div>
  );
}
